import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-report',
  templateUrl: './helpbutton-report.component.html',
  styleUrls: ['./helpbutton-report.component.scss']
})
export class HelpbuttonReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
